import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.GroupOfValuesPopup.EditGroupName', {
    label: 'Group name',
    placeholder: 'Enter a group name',
    save: 'Save',
    requiredErrorMessage: 'Name is required',
    conflictErrorMessage: 'Another group already exists with this name.',
});
